import { Card, DividerWithLabel } from '@payaca/ambrosia';
import UntitledIcon from '@payaca/untitled-icons';
import { clstx } from '@payaca/utilities/cvaMerge';
import { FC, Fragment } from 'react';

export type PipelineGuardResultGroups = {
  or: PipelineGuardResultGroup[];
};

export type PipelineGuardResultGroup = {
  and: PipelineGuardConditionResult[];
};

export type PipelineGuardConditionResult = {
  description: string;
  isSatisfied: boolean;
};

export type GuardResultDisplayProps = {
  groups: PipelineGuardResultGroups;
  className?: string;
};

const GuardResultDisplay: FC<GuardResultDisplayProps> = (props) => {
  const { groups, className } = props;

  return (
    <div className={clstx('text-center', className)}>
      <UntitledIcon name="x.3" className="text-red-800 text-3xl" />
      <h3 className="text-red-800 mt-2 mb-4">Invalid move</h3>

      {groups.or.map((group, index) => (
        <>
          {index > 0 && (
            <DividerWithLabel
              label="or"
              labelPosition="center"
              className="my-3 text-red-800 before:border-red-200 after:border-red-200"
            />
          )}
          <GuardGroup group={group} />
        </>
      ))}
    </div>
  );
};

const GuardGroup: FC<{
  group: PipelineGuardResultGroup;
}> = (props) => {
  const {
    group: { and: conditionResults },
  } = props;
  return (
    <Card
      sizeVariant="sm"
      className="text-left text-red-800 bg-transparent shadow-none border-red-200"
    >
      <Card.Body className="flex flex-col gap-1 py-3 px-3">
        {conditionResults.map((conditionResult, index) => (
          <>
            {index > 0 && <p>and</p>}
            <GuardCondition
              description={conditionResult.description}
              isSatisfied={conditionResult.isSatisfied}
            />
          </>
        ))}
      </Card.Body>
    </Card>
  );
};

const GuardCondition: FC<PipelineGuardConditionResult> = (props) => {
  const { description, isSatisfied } = props;

  return (
    <div className="flex items-start justify-between gap-2">
      {description}
      <UntitledIcon
        name={isSatisfied ? 'check' : 'x.3'}
        className={clstx(
          'h-7 w-7 shrink-0',
          isSatisfied ? 'text-green-800' : 'text-red-800'
        )}
      />
    </div>
  );
};

export default GuardResultDisplay;
